import { createUseStyles } from 'react-jss';
import { COLOR } from '../../../../common/color';

const styles = {
  accepted: {
    padding: '20px 10px',
    width: '100%',
    border: `1px solid ${COLOR.grayBorder}`,
    color: COLOR.jungleGreen,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: COLOR.white,
    borderRadius: '7px',
    overflow: 'hidden',
    fontWeight: 'bold',
  },
  rejected: {
    padding: 10,
    textAlign: 'center',
    width: '100%',
    border: `1px solid ${COLOR.grayBorder}`,
    color: COLOR.flushMahogany,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: COLOR.white,
    borderRadius: '7px',
    overflow: 'hidden',
    fontWeight: 'bold',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

/** @type {() => { [K in keyof typeof styles]: string }} */
export const useStyles = createUseStyles(styles);
